import React from 'react';
import TablePage from '../../../../../components/pages/TablePage';

export default () => {
    const columns = [
        {
            selector: (row) => row?.name,
            name: "Name",
            id: 'name',
            width: "100px"
        },
        {
            selector: (row) => row?.address,
            name: "Address",
            id: 'address'
        },
        {
            selector: (row) => row?.email,
            name: "Email",
            id: 'email'
        }
    ]
    return (
        <TablePage
            title={"Master PJT"}
            url="api/v1/pjt"
            actionPosition={'first'}
            createPath="/master/pjt/create"
            editPath={"/master/pjt/edit"}
            columns={columns}
        />
    )
}